import { AppFile } from './appFile.js'
import { apiUrl } from 'src/utils/resource.js'
import { get } from 'lodash-es'

/**
 * Describes the details of a photo media item.
 */
export class AppImage extends AppFile {

    constructor(data = {}) {
        super(data)
        this.filename = data.file_name || 'photo-placeholder.png'
        this.width = get(data.custom_properties, 'width', 0)
        this.height = get(data.custom_properties, 'height', 0)
        this.isImage = true
        this.rotationClass = ''

        this.source = data.source // raw base64 data, only available for locally created image files.
    }

    /**
     * Load some information from a js file object
     */
    loadFile(file) {
        return new Promise(resolve => {
            // Dont bother if not a valid image file
            if (!file || !file.type.match('image.*')) {
                return resolve(this)
            }

            this.file = file
            this.filename = file.name
            this.size = file.size

            let reader = new FileReader()
            reader.onload = evt => {
                let img = new Image()
                img.onload = async () => {
                    // Load dimensions of image.
                    this.width = img.width
                    this.height = img.height

                    // Determine an appropriate auto rotation transform to use based on image EXIF data
                    let orientation = await this.getOrientation(file)
                    switch (orientation) {
                        case 6:
                            this.rotationClass = 'transform: rotate(90deg)'
                            break
                        case 8:
                            this.rotationClass = 'transform: rotate(270deg)'
                            break
                        case 3:
                            this.rotationClass = 'transform: rotate(180deg)'
                            break
                    }
                    return resolve(this)
                }
                img.src = this.source = evt.target.result
            }

            reader.readAsDataURL(file)
        })
    }

    getSrc(size) {
        let timestamp = this.updatedAt.unix()
        return this.source || apiUrl(`media/${this.id || this.uuid || 0}/image?t=${timestamp}${size ? `&size=${size}` : ''}`)
    }

    getThumbnail() {
        return this.getSrc('web')
    }

    /**
     * Read the EXIF orientation of a file
     * https://stackoverflow.com/a/32490603/804484
     */
    getOrientation(file) {
        return new Promise(resolve => {
            let reader = new FileReader()
            reader.onload = evt => {
                let view = new DataView(evt.target.result)
                if (view.getUint16(0, false) != 0xFFD8) {
                    return resolve(-2)
                }
                let length = view.byteLength, offset = 2
                while (offset < length) {
                    if (view.getUint16(offset+2, false) <= 8) return resolve(-1)
                    let marker = view.getUint16(offset, false)
                    offset += 2
                    if (marker == 0xFFE1) {
                        if (view.getUint32(offset += 2, false) != 0x45786966) {
                            return resolve(-1)
                        }

                        let little = view.getUint16(offset += 6, false) == 0x4949
                        offset += view.getUint32(offset + 4, little)
                        let tags = view.getUint16(offset, little)
                        offset += 2
                        for (let i = 0; i < tags; i++) {
                            if (view.getUint16(offset + (i * 12), little) == 0x0112) {
                                return resolve(view.getUint16(offset + (i * 12) + 8, little))
                            }
                        }
                    } else if ((marker & 0xFF00) != 0xFF00) {
                        break
                    } else {
                        offset += view.getUint16(offset, false)
                    }
                }
                return resolve(-1)
            }
            reader.readAsArrayBuffer(file)
        })
    }
}
